<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <Footer> </Footer>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
}

import 'vueperslides/dist/vueperslides.css';
</script>

<style lang="scss">
@import url('https://use.typekit.net/fvg7mhk.css');
html, body{
  font-family: 'forma-djr-banner', sans-serif;
  position: relative;
  margin:0;
  padding:0;
  height: 100%;
  min-height: 100vh;
  width:100%;
  letter-spacing: 1.5px;
}

*{
  box-sizing: border-box;
}

p, .regular{
  font-size: 17.8px;
  letter-spacing: 1.5px;
  line-height: 28px;
  font-weight: 400;
  margin: 1rem 0;
  color: #727272;
}


.title{
  font-size: 38px;
  font-weight: 500;
  line-height: 44.5px;
  letter-spacing: 1.5px;
}

.subtitle{
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 3px;
}
.small_title{
  font-size: 13px;
  letter-spacing: 3px;
  font-weight: 700;
}

.color_btn{
  color: #fff;
  background: #b93f5f;
  padding: 10px 14px;
}

.container{
  margin: 0 70px;
}

a{
  text-decoration: none;
  color: #b93f5f;
}

.desktop{
  display: block;
}

button{
  &:focus{
    outline: none;
  }
  &:hover{
    cursor: pointer;
  }
  color: #fff;
  background: #b93f5f;
  border: 1px solid #b93f5f;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 300;
  text-transform: uppercase;
}

.vue-simple-spinner-text{
  letter-spacing: 3px;
  font-size: 1rem !important;
  color: #000 !important;
}

.vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper:after, .vueperslides:not(.no-shadow):not(.vueperslides--3d) .vueperslides__parallax-wrapper:before{
    box-shadow: none;
}

.top-margin{
    margin-top: 6rem;
}


@media (max-width: $mobile) {
  .container{
    margin: 0 2rem;
  }
  .desktop{
    display: none !important;
  }
  .top-margin{
      margin-top: 77px;
  }
}
</style>